import { connect } from 'react-redux';
import {
  propertiesStatsRequest,
  loadSoldPropertiesStats,
  allVisitsRequest,
  contractorsCountRequest,
} from '../../redux/actions/stats';
import { selectIsRental, selectUserData } from '../../redux/selectors/auth';
import {
  selectPropertiesStatsState,
  selectUniqueVisitorsID,
  selectAllVisitsState,
  selectContractors,
} from '../../redux/selectors/stats';
import Stats from './Stats';
import { AppState } from '../../redux/store';
import {
  selectVisitsRequestStatus,
} from '../../redux/selectors/visits';

const mapStateToProps = (state: AppState) => ({
  builderId: selectUserData(state).builderId,
  propertiesActiveCount: selectPropertiesStatsState(state).propertiesActive
    .length,
  propertiesSoldCount: selectPropertiesStatsState(state).propertiesSold.length,
  allVisitsCount: selectUniqueVisitorsID(state).length,
  contractorsServed: selectContractors(state).served,
  loadingStats:
    selectPropertiesStatsState(state).loading
    || selectAllVisitsState(state).loading
    || selectVisitsRequestStatus(state),
  isRental: selectIsRental(state.auth),
});

const mapDispatchToProps = {
  loadPropertiesStats: propertiesStatsRequest,
  loadSoldPropertiesStats,
  loadAllVisits: allVisitsRequest,
  loadContractorsCount: contractorsCountRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Stats);
